import {
  freetext_default
} from "./chunk-JTIAEL3E.js";

// src/layouts/freetext/index.ts
var freetext_default2 = freetext_default;

export {
  freetext_default2 as freetext_default
};
